<div *ngIf="timer !== 0" class="course-alert fixed-top" [class.uc-notification]="isUnifiedCode" role="status"
     [ngStyle]="{'z-index': 999 - index}">
     <button type="button" class="course-alert-close" (click)="dismiss()"
          [attr.aria-label]="'unifiedComponents.dismissNotification' | translate">
          <img loading="lazy" src="assets/imgs/close.svg" alt="" aria-hidden="true">
     </button>
     <div class="course-alert-info mx-auto">
     <div class="d-flex align-items-center">
          <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/live-video.svg);"></span>
          <span translate="home.live"></span>
     </div>
     <h5>{{title}}</h5>
     <a *ngIf="actionLink && actionLabel" class="course-alert-action" [routerLink]="actionLink">{{ actionLabel }}</a>
     <ngb-progressbar *ngIf="!isUnifiedCode" dir="ltr" [max]="10000 * index" [value]="timer"></ngb-progressbar>
     </div>
</div>
